import { ComponentProps } from 'react';
import { Button } from '../../../../../design-system/button/button';
import { Stack } from '../../../../../design-system/stack/stack';
import { InvoiceCard } from '../invoice-card';

type MarkNotInvoiceModalContentProps = {
  invoiceInfo: ComponentProps<typeof InvoiceCard>;
  isLoading: boolean;
  onMarkNotInvoice: () => Promise<void>;
};

export const MarkNotInvoiceModalContent = ({
  invoiceInfo,
  isLoading,
  onMarkNotInvoice,
}: MarkNotInvoiceModalContentProps) => {
  return (
    <Stack space={10} align="stretch">
      <Stack space={4} align="stretch">
        <Stack space={4} align="stretch">
          <h1 className="text-xl font-medium leading-6 tracking-tight text-black">Mark as not invoice</h1>

          <p className="text-base font-medium leading-6 tracking-tight text-seapoint-gray-text">
            This will remove the invoice from your queue and not automatically pull in similar invoice in the future.
          </p>
        </Stack>

        <InvoiceCard {...invoiceInfo} />
      </Stack>

      <Button variant="default" isLoading={isLoading} onClick={onMarkNotInvoice}>
        Mark as not invoice
      </Button>
    </Stack>
  );
};
